// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"328":"4af6f154","720":"57da29b4","996":"84663cbc"}[chunkId] + ".css";
};